import { FeatureSessionStore } from "../app/uidispatcherapi/FeatureSessionStore";
import Features from "../app/uidispatcherapi/Features";

export function articleSourcesFeatureActive(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.ARTICLE_SOURCES_FACET) === "B";
}
export function isXForYFeatureActive(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.SD_X_FOR_Y) === "B";
}

export function isBulkPricesFeatureActive(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.SD_BULK_PRICES) === "B";
}

export function isShowCSatSurveyActive(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.SD_SHOW_ARTICLLESEARCH_CSAT) === "B";
}

export function suggestionsDebug(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.SUGGESTIONS_DEBUG) === "B";
}

export function fsdFilterAlwaysActiveForStoreDeliveryCustomers(): boolean {
    return (
        FeatureSessionStore.getMembershipFor(Features.SD_FSD_FILTER_ALWAYS_ACTIVE_FOR_STORE_DELIVERY_CUSTOMERS) === "B"
    );
}

export function dontShowInfoSuggestions(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.SD_NO_INFO_SUGGESTIONS) === "B";
}

export function showMetroXStoreSelectorFSD(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.SD_SHOW_METRO_X_STORE_SELECTOR_FSD) === "B";
}

export function showMetroXStoreSelectorCCOV(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.SD_SHOW_METRO_X_STORE_SELECTOR_CCOV) === "B";
}

export function isSearchDebugEnabled() {
    return FeatureSessionStore.getMembershipFor(Features.SEARCH_DEBUG) === "B";
}

export function isShowReorderButtonEnabled() {
    return FeatureSessionStore.getMembershipFor(Features.CIA_REORDER_BUTTON) === "B";
}

export function shouldUseMetroXAccountFlyout(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.CA_USE_METROX_ACCOUNT_FLYOUT) === "B";
}

export function isListOverviewPageSortingScoringActive() {
    return FeatureSessionStore.getMembershipFor(Features.LISTPAGE_SORTING_SCORING) === "B";
}

//search profile related toggles
export function isSuggestContentEnabled() {
    return FeatureSessionStore.getMembershipFor(Features.SD_SUGGEST_CONTENT) === "B";
}

const searchProfileToggles = [
    Features.SD_SUGGEST_CONTENT,
    Features.SD_BOOST_ARTICLE_ATTRIBUTES,
    Features.SD_ALTERNATIVE_STEMMING,
    Features.SD_BOOST_CUSTOMER_TARGET_GROUPS,
    Features.SD_BOOST_OWN_BRAND
];
export function isSearchProfileEnabled(key: string) {
    if (searchProfileToggles.includes(key)) {
        return FeatureSessionStore.getMembershipFor(key) === "B";
    }
    return false;
}

export function isFixedContentWidth() {
    return FeatureSessionStore.getMembershipFor(Features.ENABLE_FIXED_WIDTH_CONTENT) === "B";
}

export function shouldUseNewCreateListsButton() {
    return FeatureSessionStore.getMembershipFor(Features.CIA_NEW_CREATE_LISTS_BUTTON) === "B";
}

export const isNewAccountFlyoutFallbackEnabled = () => {
    return FeatureSessionStore.getMembershipFor(Features.CIA_NEW_ACCOUNT_FLYOUT_FALLBACK) === "B";
};

export function isNewFooterEnabled() {
    return FeatureSessionStore.getMembershipFor(Features.CI_NEW_FOOTER) === "B";
}

export function getNewLayoutNotificationFeatureEnabled() {
    return FeatureSessionStore.getMembershipFor(Features.CIA_NEW_CUSTOMER_PORTAL_MENU_CHANGE_NOTIFICATION) === "B";
}

export function getNewCustomerPortalMenuFeatureEnabled() {
    return FeatureSessionStore.getMembershipFor(Features.CIA_NEW_CUSTOMER_PORTAL) === "B";
}
